<template>
  <div v-if="showRecordItem">
    <v-layout wrap>
      <v-flex xs12 class="my-1 mr-10">
        <v-flex d-flex align-baseline class="mb-6">
          <div v-if="RecordItem.children.length">
            <v-icon @click="expanded = !expanded" class="mb-1 mr-1">
              {{ this.expanded ? mdiChevronDown : mdiChevronRight }}
            </v-icon>
          </div>

          <FormFactory
            :node="RecordItem"
            :editMode="editMode"
            :showDateMode="showDateMode"
            :selectedRecord="selectedRecord"
            :isRoot="isRoot"
            v-on:resetform="emitResetForm()"
          />
        </v-flex>

        <v-divider></v-divider>
      </v-flex>

      <v-flex v-if="expanded" xs12 offset-xs1>
        <div v-for="(child, index) in RecordItem.children" :key="index">
          <RecordNode
            :RecordItem="child"
            v-on:resetform="emitResetForm()"
            v-on:resetformplease="emitResetForm()"
            :editMode="editMode"
            :showDateMode="showDateMode"
          />
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RecordNode from "./RecordNode";
import FormFactory from "../FormFactory";
import { mdiChevronRight, mdiChevronDown } from "@mdi/js";
export default {
  props: {
    RecordItem: Object,
    editMode: Boolean,
    showDateMode: Boolean,
    isRoot: Boolean
  },
  components: {
    FormFactory
  },
  mounted() {},

  name: "RecordNode",
  computed: {
    ...mapState({
      selectedRecord: state => state.records.currentlySelectedRecord,
      conditionallyHiddenNodes: state =>
        state.records.conditionallyHiddenRecordItemIds
    }),
    showRecordItem: function() {
      for (let id of this.conditionallyHiddenNodes) {
        if (id == this.RecordItem._id) {
          return false;
        }
      }
      return true;
    }
  },
  data() {
    return {
      expanded: true,
      mdiChevronRight,
      mdiChevronDown
    };
  },
  methods: {
    emitResetForm() {
      this.$emit("resetformplease");
    }
  }
};
</script>

<style></style>
